import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FlightSearchComponent } from '../../../flights/components/flight-search/flight-search.component';

@Component({
  selector: 'app-home-page',
  imports: [NgClass, TranslateModule, FlightSearchComponent],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.css',
})
export class HomePageComponent {
  @ViewChild('homeSection') homeSection!: ElementRef;

  featureCards = [
    {
      icon: '/icons/one-plane.svg',
      label: 'Home_Page.Feature_Card.Label_One',
      alt: 'style-plane',
      iconWithHover: '/icons/one-plane-hover.svg',
    },
    {
      icon: '/icons/Award-Star.svg',
      label: 'Home_Page.Feature_Card.Label_Two',
      alt: 'award-star',
      iconWithHover: '/icons/award-hover.svg',
    },
    {
      icon: '/icons/secure.svg',
      label: 'Home_Page.Feature_Card.Label_Three',
      alt: 'secure',
      iconWithHover: '/icons/secure-hover.svg',
    },
    {
      icon: '/icons/network.svg',
      label: 'Home_Page.Feature_Card.Label_Four',
      alt: 'network',
      iconWithHover: '/icons/network-hover.svg',
    },
  ];

  cards = [
    {
      title: 'Home_Page.Steps.Title_One',
      body: 'Home_Page.Steps.Body_One',
    },
    {
      title: 'Home_Page.Steps.Title_Two',
      body: 'Home_Page.Steps.Body_Two',
    },
    {
      title: 'Home_Page.Steps.Title_Three',
      body: 'Home_Page.Steps.Body_Three',
    },
    {
      title: 'Home_Page.Steps.Title_Four',
      body: 'Home_Page.Steps.Body_Four',
    },
    {
      title: 'Home_Page.Steps.Title_Five',
      body: 'Home_Page.Steps.Body_Five',
    },
    {
      title: 'Home_Page.Steps.Title_Six',
      body: 'Home_Page.Steps.Body_Six',
    },
  ];

  marqueeTexts = [
    { text: 'Home_Page.Marquee.Text_One', color: 'text-[#7C7C9A]' },
    { text: 'Home_Page.Marquee.Text_Two', color: 'text-outlined' },
    { text: 'Home_Page.Marquee.Text_Three', color: 'text-[#7C7C9A]' },
    { text: 'Home_Page.Marquee.Text_Four', color: 'text-muted' },
    { text: 'Home_Page.Marquee.Text_Five', color: 'text-[#7C7C9A]' },
    { text: 'Home_Page.Marquee.Text_Six', color: 'text-muted' },
    { text: 'Home_Page.Marquee.Text_Seven', color: 'text-outlined' },
    { text: 'Home_Page.Marquee.Text_Eight', color: 'text-[#7C7C9A]' },
    { text: 'Home_Page.Marquee.Text_Nine', color: 'text-muted' },
  ];

  get isDark() {
    return localStorage.getItem('theme') === 'dark';
  }

  scrollToTop() {
    this.homeSection.nativeElement.scrollIntoView({
      behavior: 'smooth',
    });
  }
}
